import React from "react";
import ActiveUpload from "./active-upload.jsx";

const ActiveUploadList = ({ uploads }) => (
    <ul id="icons-uploaded" className="clearfix dashboard-user">
        {uploads &&
            uploads.map(upload => (
                <ActiveUpload upload={upload} key={upload.id} />
            ))}
    </ul>
);

export default ActiveUploadList;
